import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 4l3 3","key":"svg-0"}],["path",{"d":"M18.5 5.5l-8 8","key":"svg-1"}],["path",{"d":"M8.276 11.284l4.44 4.44a.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a.968 .968 0 0 1 1.37 0l-.001 0","key":"svg-2"}]]

const IconShovel = createReactComponent('outline', 'shovel', 'Shovel', __iconNode);

export default IconShovel;